import styled from 'styled-components'
import SVG from 'react-inlinesvg'

const icons: { [key: string]: string } = {
  'Top 10': 'podium',
  'Luxe et lifestyle': 'luxury',
  CEO: 'ceo',
  Horlogerie: 'horlogy',
  Banque: 'bank',
  Investissement: 'invest',
  Immobilier: 'building',
  'Négoce et shipping': 'shipping',
  Divertissement: 'stadium',
  Retail: 'basket',
  Technologie: 'technology',
  Agroalimentaire: 'agro',
  Industrie: 'industry',
  'Chimie-pharma': 'chemistry',
  Services: 'services',
}


export const MainSectorsIcons = ({ icon }: { icon: string }) => {
  return (
    <div>
    <Icon
      title={`Icône de ${icon}`}
      src={require(`../../images/pictos/${icons[icon] || 'misc'}.svg`)}
      color='#ffffff'
    />
    </div>
  )
}

const Icon = styled(SVG)`
  width: 30px;
  height: auto;

  path {
    fill: ${({ theme }) => theme.colorMain};
  }
`
